import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
export const EmptyGridChildPlaceholder = () => (_jsx("div", {}));
